<template>
  <div>
    <el-drawer
      ref="drawer"
      :title="title"
      :visible.sync="drawer"
      size="70%"
      :before-close="beforeClose"
      :wrapperClosable="false"
      :append-to-body="true"
      @close="onClose"
      v-bind="$attrs"
    >
      <el-container>
        <el-main>
          <el-row :gutter="20">
            <el-col :span="13" :sm="24" :md="13" :xs="24">
              <!-- SECCIÓN DE FORMULARIO -->
              <el-form
                :model="model"
                ref="form"
                :rules="rules"
                label-width="150px"
                size="mini"
                label-position="left"
              >
                <h3>
                  <a href="#" @click="handlerClick">
                    Objetivo #{{ model.ObjetiveID }} - {{ model.ObjetiveName }}
                  </a>
                  <p v-if="model.DateEndObjetive">
                    Fecha fin del Objetivo:
                    {{ model.DateEndObjetive.slice(0, 10) }}
                  </p>
                </h3>
                <h3 v-show="model.ID !== undefined > 0">
                  Tarea #<strong>{{ this.model.ID }} - </strong>
                  <el-tag
                    :v-if="false"
                    :type="
                      TaskStatusLabel === 'Retrasada' ? 'danger' : 'default'
                    "
                  >
                    {{
                      TaskStatusLabel && this.model.ID ? "Pendiente" : "Nueva"
                    }}</el-tag
                  >
                </h3>

                <hr style="margin-bottom: 15px" />

                <!-- Nombre y Descripcion -->
                <el-form-item label="Nombre" prop="Name">
                  <el-input
                    v-model="model.Name"
                    :disabled="!canEdit"
                    placeholder="Nombre de la tarea"
                  ></el-input>
                </el-form-item>

                <el-row>
                  <el-col>
                    <el-form-item label-width="0" prop="Description">
                      <quill-editor
                        :disabled="!canEdit"
                        ref="myQuillEditor"
                        v-model="model.Details"
                        style="height: 250px; margin-bottom: 45px"
                      ></quill-editor>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="18">
                    <el-form-item label="Creado por">
                      <el-input
                        v-model="model.ObjetiveCreated"
                        style="width: 27%"
                        disabled
                      ></el-input>
                    </el-form-item>

                    <el-form-item label="Estatus">
                      <el-tooltip
                        class="tolltipStatus"
                        effect="light"
                        :disabled="!IsNewTask"
                        content="Solo es posible cambiar el estatus cuando se edita la tarea"
                        placement="right"
                      >
                        <el-select
                          v-model="model.PercentageProsposal"
                          style="width: 27%"
                          placeholder="Estatus"
                          :disabled="IsNewTask"
                        >
                          <el-option
                            v-for="item in status"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                            <span
                              :style="{ float: 'left', color: item.color }"
                              >{{ item.label }}</span
                            >
                          </el-option>
                        </el-select>
                      </el-tooltip>
                    </el-form-item>

                    <el-form-item label="Responsable" prop="ResponsableId">
                      <el-select
                        v-model="model.ResponsableId"
                        :disabled="!canEdit"
                        placeholder="Responsable de la tarea"
                        style="width: 27%"
                        filterable
                        clearable
                      >
                        <el-option
                          v-for="item in responsibles"
                          :key="item.EmployeeID"
                          :label="item.label"
                          :value="item.value"
                          >{{ item.Name }}</el-option
                        >
                      </el-select>
                    </el-form-item>

                    <el-form-item
                      v-if="isCEO"
                      label="Tipo Tarea"
                      prop="Typetask"
                      style="font-weight: bold; margin-top: 40px"
                    >
                      <el-select
                        style="width: 30%"
                        v-model="model.Typetask"
                        placeholder="Seleccionar un Tipo"
                        filterable
                      >
                        <el-option
                          label="ESTRATEGICOS"
                          value="ESTRATEGICO"
                        ></el-option>
                        <el-option
                          label="GERENCIAL"
                          value="GERENCIAL"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="Fecha Inicio" prop="InitialDate">
                      <el-date-picker
                        type="datetime"
                        placeholder="Fecha Inicio"
                        v-model="model.InitialDate"
                        :disabled="!IsSuperVisor || !canEdit"
                      ></el-date-picker>
                      <div class="el-form-item__error" v-if="initerror">
                        {{ msgInterior }}
                      </div>
                    </el-form-item>

                    <el-form-item
                      label="Fecha Fin"
                      :class="errorfield"
                      prop="LimitDate"
                    >
                      <el-date-picker
                        type="datetime"
                        placeholder="Fecha Fin"
                        v-model="model.LimitDate"
                        :disabled="!IsSuperVisor || !canEdit"
                      ></el-date-picker>
                      <div v-if="errorDate" class="el-form-item__error">
                        {{ msg }}
                      </div>
                    </el-form-item>

                    <el-form-item
                      style="width: 50%; min-width: 500px"
                      prop="qty"
                      label="Tiempo estimado"
                    >
                      <el-col :span="12">
                        <el-input-number
                          v-model="model.qty"
                          placeholder="Cantidad"
                          :min="1"
                          :disabled="!IsSuperVisor || !canEdit"
                        />
                        <!-- <el-input
                          v-model="model.qty"
                          placeholder="Cantidad"
                          type="number"
                          :min="1"
                          :disabled="!IsSuperVisor"
                          @input="model.qty = parseInt(model.qty)"
                        /> -->
                      </el-col>
                      <el-col :span="12">
                        <el-select
                          v-model="typeQ"
                          placeholder="Typo"
                          style="width: 45%"
                          :disabled="!IsSuperVisor || !canEdit"
                          @change="model.type = $event"
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <!-- BOTON PARA EDITAR Y VER EL DOCUMENTO DE EVIDENCIA -->
                    <el-row style="display: flex; float: right">
                      <el-button
                        v-if="canEdit && this.fileURL"
                        type="primary"
                        size="mini"
                        icon="el-icon-edit"
                        v-on:click="handleEditFile"
                      >
                      </el-button>
                      <el-button
                        type="primary"
                        icon="el-icon-document"
                        size="mini"
                        v-on:click="openFile(null)"
                        v-if="this.fileURL"
                        >Ver Evidencia</el-button
                      >
                    </el-row>
                  </el-col>
                </el-row>

                <el-form-item label-width="0">
                  <el-button type="default" @click="onCancelDrawer"
                    >Cancelar</el-button
                  >
                  <el-button
                    v-show="canEdit"
                    type="primary"
                    :loading="loading_save"
                    :disabled="!IsSuperVisor && this.isCreated"
                    @click="onSubmit"
                    >{{ "Guardar" }}</el-button
                  >
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="10" :offset="1" :sm="23" :md="10" :xs="23">
              <!-- SECCIÓN DE COMENTARIOS -->
              <el-row>
                <el-col>
                  <el-button
                    type="primary"
                    size="mini"
                    style="float: right"
                    @click="addComment"
                  >
                    Nuevo Comentario
                  </el-button>
                </el-col>
              </el-row>
              <el-tabs v-model="activeName">
                <h3 v-if="comments.length == 0">
                  No hay comentarios en esta tarea
                </h3>
                <el-tab-pane name="comments">
                  <span slot="label"
                    ><i class="el-icon-chat-dot-round"></i> Comantarios</span
                  >
                  <CommentList
                    v-if="comments.length > 0"
                    :comments="comments"
                    :loading.sync="loading_comments"
                    key-content="Content"
                  />
                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-drawer>
    <ObjetiveForm ref="objetiveform" @update-data="getUpdatedData" />

    <!-- DIALOG DE EVIDENCIA -->
    <el-dialog
      title="Suministrar Evidencia"
      :visible.sync="viewEvidenceDialog"
      :append-to-body="true"
      width="36%"
    >
      <span
        >Al terminar una tarea se necesita proporcionar una evidencia del
        cumplimiento de la misma.<br />
        <strong
          >Favor colocar una captura de pantalla o un documento que compruebe la
          finalización de esta tarea.
        </strong>
      </span>

      <!-- FILE UPLOADER -->
      <el-upload
        ref="uploadFile"
        class="upload-demo"
        action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
        style="margin-left: 20%; margin-top: 20px"
        :v-show="fileEvidence"
        :drag="true"
        :auto-upload="false"
        :multiple="true"
        :file-list="fileList"
        :limit="1"
        :on-exceed="handleExceed"
        :on-success="handleSuccess"
        :on-error="handleError"
      >
        <!--:on-progress="handleProgress"-->
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Suelta tu archivo aquí o <em>haz clic para cargar</em>
        </div>
        <div slot="tip" class="el-upload__tip" style="margin-left: 50px">
          Solo archivos con un tamaño menor de 26MB
        </div>
      </el-upload>

      <!-- BOTON -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel">Cancelar</el-button>
        <el-button
          type="primary"
          @click="saveDocument"
          v-loading="UploadLoading"
          >Confirmar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import { formatDate, formatArrayToElSelect } from "@/utils";
import { TaskStatus } from "@/views/apps/cmi/tasks/TaskStatus";
import ObjetiveForm from "./ObjectiveForm.vue";
import CommentList from "@/components/comments/CommentList";
import { BASE_API_URL } from "@/const";

export default {
  name: "TaskForm",
  inheritAttrs: false,
  components: {
    quillEditor,
    ObjetiveForm,
    CommentList
  },
  props: {
    currentActionSelected: {
      type: String,
      default: ""
    },
    currentActionForDelayedTask: {
      type: String,
      default: ""
    }
  },
  data() {
    let self = this;
    return {
      uploadUrl: "",
      BASE_API_URL,
      activeName: "comments",
      drawer: false,
      title: "Nueva tarea",
      objetiveName: "",
      canEdit: false,
      msg: "",
      typeQ: "hour",
      model: {
        ID: null,
        Name: "",
        Description: "",
        Typetask: "",
        ResponsableId: "",
        deparment: "",
        ProposalDate: "",
        Status: "",
        InitialDate: Date.now(),
        LimitDate: Date.now(),
        Percentage: 0,
        PercentageProsposal: 0,
        ObjetiveID: null,
        CompanySelected: null,
        CreatedBy: 0,
        type: self.typeQ,
        qty: 0
      },
      options: [
        {
          value: "day",
          label: "Día"
        },
        {
          value: "hour",
          label: "Hora"
        }
      ],

      rules: {
        Name: [
          {
            required: true,
            message: "El nombre de la tarea es requerido",
            trigger: "change"
          }
        ],
        Description: [
          {
            required: true,
            message: "La descripcion de la tarea es requerida",
            trigger: "change"
          }
        ],
        ResponsableId: [
          {
            required: true,
            message: "El reponsable de la tarea es querido",
            trigger: "change"
          }
        ],
        Typetask: [
          {
            required: true,
            message: "El Tipo de la tarea es querido",
            trigger: "change"
          }
        ],
        InitialDate: [
          {
            type: "date",
            required: true,
            message: "La fecha de inicio es requerida",
            trigger: "change"
          },
          {
            type: "date",
            trigger: "blur",
            validator: (rule, value, callback) => {
              const startTaskDate = new Date(value);
              const startObjetuveDate = new Date(this.ObjectiveDateUnformated);

              if (startTaskDate.getTime() > startObjetuveDate.getTime()) {
                return Promise.reject(
                  "La fecha no debe ser mayor a la fecha del objetivo"
                );
              } else {
                callback();
              }
            }
          }
        ],
        LimitDate: [
          {
            type: "date",
            required: true,
            message: "La fecha de fin es requerida",
            trigger: "change"
          },
          {
            type: "date",
            trigger: "blur",
            validator: (rule, value, callback) => {
              const startTaskDate = new Date(value);
              const xTaskDate = new Date(self.model["InitialDate"]);
              const startObjetuveDate = new Date(this.ObjectiveDateUnformated);
              if (startTaskDate.getTime() > startObjetuveDate.getTime()) {
                self.$alert(
                  `Saludos, por favor solicitar al creador de la tarea que modifique la fecha limite
                  para que esta sea menor a \n ${formatDate(
                    startObjetuveDate,
                    "YYYY/MM/DD HH:MM:SS"
                  )}`,
                  "Fecha limite del objetivo"
                );

                return Promise.reject(
                  "La fecha no debe ser mayor a la fecha del objetivo"
                );
              }
              if (xTaskDate.getTime() >= startTaskDate.getTime()) {
                return Promise.reject(
                  "La fecha limite debe ser mayor que la fecha de inicio"
                );
              } else {
                callback();
              }
            }
          }
        ],
        qty: [
          {
            type: "number",
            required: true,
            messge: "El tiempo estimado es requerido",
            trigger: "change"
          },
          {
            type: "number",
            trigger: "change",
            validator: async (rule, value, callback) => {
              if (
                self.model["InitialDate"] === undefined ||
                self.model["LimitDate"] === undefined
              ) {
                return Promise.reject(
                  `Primero agregue fecha de inicio y final`
                );
              }

              const type = self.model.type;
              const taskInit = new Date(self.model.InitialDate);
              const taskLimit = new Date(self.model.LimitDate);
              const message =
                "El tiempo estimiado no debe exceder el rando de la fecha inicio y fin";

              // Siempre sumamo un dia para poder validar
              taskLimit.setDate(taskLimit.getDate() + 1);

              if (type === "hour") {
                taskInit.setHours(taskInit.getHours() + Number(value));

                if (taskInit.getTime() > taskLimit.getTime()) {
                  return Promise.reject(message);
                }
              }

              if (type === "day") {
                taskInit.setDate(taskInit.getDate() + Number(value));

                if (taskInit.getTime() > taskLimit.getTime()) {
                  return Promise.reject(message);
                }
              }

              callback();
            }
          }
        ]
      },
      responsibles: [],
      status: TaskStatus,
      loading_save: false,
      loading_comments: false,
      isCreated: false,
      data: {},
      errorDate: false,
      initerror: false,
      msgInterior: "",
      comments: [],
      viewEvidenceDialog: false,
      fileList: [],
      fileEvidence: false,
      fileURL: "",
      fileType: "",
      fileView: false,
      UploadLoading: false,
      ObjectiveName: "",
      ObjectiveDateEndDisplay: "",
      ObjectiveDateUnformated: "",
      TaskStatusLabel: ""
    };
  },
  created() {
    if (this.currentUser.IsSupervisor && this.isCreated) {
      this.$message({
        type: "error",
        message: "Usted no puede crear tarea",
        duration: 5 * 1000
      });
    }
  },
  mounted() {
    if (process.env.NODE_ENV !== "development") {
      //console.log("mounted: ", this.model)
      this.uploadUrl = `${BASE_API_URL}/api/CMI/Task/UploadFile?TaskID=${this.model.ID}`;
    } else {
      //console.log("ID model: ",this.model.ID)
      this.uploadUrl = `/api/CMI/Task/UploadFile?TaskID=${this.model.ID}`;
    }
  },
  computed: {
    errorfield() {
      if (this.errorDate) {
        return "is-error is-required";
      } else {
        return "";
      }
    },
    isCEO() {
      return this.currentUser.Roles.some((rol) => rol.Name == "CEO");
    },
    IsSuperVisor() {
      return this.currentUser.IsSupervisor;
    },
    isOwner() {
      return this.model.CreatedBy === this.currentUser.UserID;
    },
    IsNewTask() {
      //console.log("accion", this.currentActionSelected)
      if (
        this.currentActionSelected === "view-task-view" ||
        this.currentActionSelected === "task-agregar-nueva"
        //this.currentActionSelected === "view-task-edit"
      ) {
        return true;
        //condicion para bloquear el estatus de las tareas retrasadas
      } /* else if (this.currentActionForDelayedTask === "tranque") {
         if (
           this.currentActionSelected === "view-task-view" ||
           this.currentActionSelected === "view-task-edit"
           //this.currentActionSelected === "view-task-edit"
         ) {
           return true;
         }
         return false;
       } */ else {
        return false;
      }
    },
    // IsEditFromDelay() {

    // },
    CreateByName: {
      get() {
        if (!this.model.CreatedBy) return "";
        //console.log("LOG STORE", this.$store.getters);
        const user = this.$store.getters["user/getUserById"](
          this.model.CreatedBy
        );
        return user !== undefined ? user.FullName : "";
      }
    }
  },
  methods: {
    async ValidateDate() {
      const ValidateUri = "/api/CMI/Task/ValidateDate";
      const params = {
        taskdate: formatDate(this.model.LimitDate, "YYYY/MM/DD"),
        type: this.model.type,
        estimated: Number(this.model.qty),
        ObjetiveId: Number(this.model.ObjetiveID)
      };
      const { data } = await this.$http.post(ValidateUri, params);

      if (data.CanSave === false) {
        const date = formatDate(data.ObjetiveDate, "YYYY/MM/DD");
        this.$notify.error({
          title: "Fecha de tarea Invalida",
          dangerouslyUseHTMLString: true,
          position: "top-right",
          message: `<p> La fecha de cierre sugerida no puede ser mayor a la del objetivo. </p> <br> la fecha debe ser menor a <strong>${date} </strong> `,
          duration: 15000
        });
        this.errorDate = true;
        this.msg = `Fecha invalida, esta debe ser menor a la fecha del objetivo`;
        return false;
      } else {
        return true;
      }
    },
    async handlerClick() {
      const uri = `/api/CMI/Objetives/getGanttObjetiveByID?Id=${this.model.ObjetiveID}`;
      const response = await this.$http.get(uri);
      const { data } = response;
      const ndata = {
        ...data,
        perspectiveName: data.Name,
        Owner: data.CreatedBy,
        ResposibleID: data.ResponsableId
      };

      this.$refs.objetiveform.show(ndata, false, true, false);
    },
    formatDate,
    formatArrayToElSelect,

    NotEmpty(content) {
      if (content == null) {
        return false;
      } else {
        while (content.trim().length == 0) {
          return false;
        }
      }
    },

    getComments() {
      this.loading_comments = true;
      this.$http
        .get("/api/CMI/Task/getcommentsbyTaskID", {
          params: {
            taskid: this.model.ID
          }
        })
        .then((response) => {
          this.comments = response.data;
        })
        .finally(() => {
          this.loading_comments = false;
        });
    },

    addComment() {
      this.$prompt("Escriba su comentario", "Nuevo Comentario", {
        confirmButtonText: "Enviar",
        cancelButtonText: "Cancel",
        inputValidator: this.NotEmpty,
        inputErrorMessage: "El comentario no puede estar vacío"
      })
        .then(({ value }) => {
          //Api request
          this.$http
            .post("/api/CMI/Task/addComment", {
              UserId: this.currentUser.UserID,
              CompanySelected: this.currentCompany,
              TaskId: this.model.ID,
              ObjetiveID: this.model.ObjetiveID,
              Content: value
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "Mensaje agregado con éxito"
              });
            })
            .finally(this.getComments);
        })
        .catch(() => {});
    },

    show(
      data = {},
      isView = false,
      isCreated = false,
      isEdit = false,
      Aprobar = false
    ) {
      this.canEdit = false;
      //console.log("Estamos en TaskForm");
      //console.log("show", data);
      this.loading_save = false;
      this.errorDate = false;
      this.initerror = false;
      if (data.objective) {
        this.TaskStatusLabel = data.task.Status;
        this.ObjectiveName = data.objective.Name;
        this.ObjectiveDateUnformated = data.objective.DateEnd;
        this.ObjectiveDateEndDisplay = formatDate(
          data.objective.DateEnd,
          "DD/MM/YYYY"
        );
      } else {
        this.ObjectiveName = data.Name;
        this.ObjectiveDateUnformated = data.DateEnd;
        this.ObjectiveDateEndDisplay = formatDate(data.DateEnd, "DD/MM/YYYY");
      }

      // para nueva tarea
      if (isCreated) {
        this.canEdit = true;
        this.clear(false);
        this.model.ObjetiveID = data.ID;
        this.title = "Nueva tarea";
        this.data = data;
      }

      if (isView) {
        this.title = "Información de tarea";
        this.isCreated = false;
        this.model = {
          ...this.model,
          ...data.task,
          InitialDate: new Date(data.task.InitialDate),
          LimitDate: new Date(data.task.LimitDate)
        };
        this.isView = isView;
        this.data = data.task.row;
        this.typeQ = data.task.type;
        this.getComments();
      }

      if (Aprobar) {
        this.title = "Tareas por Aprobar";
        this.isCreated = false;
        this.model = {
          ...this.model,
          ...data.task,
          InitialDate: new Date(data.task.InitialDate),
          LimitDate: new Date(data.task.LimitDate)
        };
        this.isView = isView;
        this.data = data.objective.row;
      }

      if (isEdit) {
        this.canEdit = true;
        this.title = "Actualizar Tarea";
        this.isCreated = false;
        const initF = new Date(data.task.InitialDate);
        const limitF = new Date(data.task.LimitDate);
        this.model = {
          ...this.model,
          ...data.task,
          InitialDate: initF,
          LimitDate: limitF
        };
        this.data = data.task.row;
        this.typeQ = data.task.type;
      }
      this.loadUsersfromServer();
      this.drawer = true;

      const documentUrl = this.model.DocumentURL;
      if (documentUrl) {
        //console.log("documentUrl: " + documentUrl);
        this.fileURL = documentUrl;
        this.fileType = documentUrl.substr(documentUrl.length - 4);
      }

      // this.getFileURL();
    },

    clear(resetFields = true) {
      if (resetFields) {
        this.$refs.form.resetFields();
        (this.ObjectiveName = ""), (this.ObjectiveDateEndDisplay = "");
      }
      this.model = {
        ...this.model,
        ID: null,
        Name: "",
        Typetask: "",
        Description: "",
        ResponsableId: "",
        deparment: "",
        Percentage: 0,
        date1: "",
        date2: "",
        ObjetiveID: null
      };
    },
    async onSubmit() {
      //aqui es conaso
      this.evidenceDialog();
      if (this.viewEvidenceDialog === false) {
        this.saveForm();
      }
      var DueDate = this.model.LimitDate.getTime();
      var Today = Date.now();
      if (DueDate > Today) {
        this.$emit("update-table");
      }
    },
    saveForm() {
      this.$refs.form.validate((valid) => {
        this.loading_save = true;
        //console.log("this.currentCompany: ", this.currentCompany);
        if (valid) {
          const body = {
            ...this.model,
            CompanySelected: this.currentCompany,
            ProposalDate: this.model.LimitDate,
            InitialDate: this.model.InitialDate,
            LimitDate: this.model.LimitDate,
            CombinedId: "Task-" + this.model.ID
          };
          this.$http
            .post("/api/cmi/task/AddTaskGantt", body)
            .then(() => {
              this.$emit("submit-success");
              let message = "La tarea fue creada";
              if (body.ID) {
                message = "La tarea fue editada";
              }
              this.$message.success(message);

              this.$emit("update");
              this.clear();
              this.drawer = false;
            })
            .catch((err) => {
              console.error(err);
            })
            .finally(() => {
              this.loading_save = false;
              this.onCancel();
              this.$emit("update-table");
            });

          if (!this.model.ID) {
            // valida que la fecha inicio no sea menor a la actual
            // const fecha_tarea = moment(this.model.LimitDate)
            //   .minutes(0)
            //   .seconds(0);
            // const fecha_tarea_inicio = moment(this.model.InitialDate)
            //   .minutes(0)
            //   .seconds(0);
            // const now = moment(formatDate(new Date(), "YYYY/MM/DD"))
            //   .minutes(0)
            //   .seconds(0)
            //   .add(0, "hours");
            //   if (fecha_tarea.isBefore(now)) {
            //     this.$notify({
            //       title: "Fecha invalida",
            //       duration: 6000,
            //       type: "error",
            //       position: "top-right",
            //       message:
            //         "la fecha limite no pueede estar antes de la fecha actual"
            //     });
            //     this.loading_save = false;
            //     // set message for ending task
            //     this.msg = "Fecha invalida, esta debe ser mayor a la actual";
            //     this.errorDate = true;
            //     this.msgInterior = "";
            //     this.initerror = false;
            //     return;
            //   }
            //   if (fecha_tarea_inicio.isBefore(now)) {
            //     this.$notify({
            //       title: "Fecha invalida",
            //       duration: 6000,
            //       type: "error",
            //       position: "top-right",
            //       message:
            //         "la fecha de inicio no pueede estar antes de la fecha actual"
            //     });
            //     this.loading_save = false;
            //     this.msgInterior =
            //       "Fecha invalida, esta debe ser mayor a la actual";
            //     this.initerror = true;
            //     this.msg = "";
            //     this.errorDate = false;
            //     return;
            //   }
            // }
            // this.$http
            //   .post("/api/cmi/task/add", body)
            //   .then(() => {
            //     this.$emit("submit-success");
            //     let message = "La tarea fue creada";
            //     if (!this.isCreated) {
            //       message = "La tarea fue editada";
            //     }
            //     this.$message.success(message);
            //     this.$emit("update");
            //     this.clear();
            //     this.drawer = false;
            //   })
            //   .catch(err => {
            //     console.error(err);
            //   })
            //   .finally(() => {
            //     this.loading_save = false;
            //   });
            // const validation = this.ValidateDate();
            // if (!validation) {
            //   this.msg = "La fecha de fin es invalida";
            //   this.loading_save = false;
            //   this.errorDate = true;
            //   return;
            // } else {
            //   this.errorDate = false;
            //   this.$http
            //     .post("/api/cmi/task/add", body)
            //     .then(() => {
            //       this.$emit("submit-success");
            //       let message = "La tarea fue creada";
            //       if (!this.isCreated) {
            //         message = "La tarea fue editada";
            //       }
            //       this.$message.success(message);
            //       this.$emit("update");
            //       this.clear();
            //       this.drawer = false;
            //     })
            //     .catch(err => {
            //       console.error(err);
            //     })
            //     .finally(() => {
            //       this.loading_save = false;
            //     });
          }
        } else {
          this.loading_save = false;
          this.drawer = true;
          return false;
        }
      });
    },
    beforeClose(done) {
      this.$emit("update");
      this.clear(true);
      this.comments = [];
      this.canEdit = false;
      this.fileURL = "";
      done();
    },
    loadUsersfromServer() {
      const { EmployeeId } = this.currentUser;

      this.loading_user = true;

      this.$http
        .get(`/api/CMI/Objetives/GetUsersObjetivos`, {
          params: {
            CompanySelected: this.currentCompany,
            employeeid: EmployeeId
          }
        })
        .then((response) => {
          this.responsibles = this.formatArrayToElSelect(response.data, {
            label: "Name",
            value: "EmployeeID"
          });
        })
        .catch((er) => {
          console.error(er);
        })
        .finally(() => {
          this.loading_user = false;
        });
    },
    // eslint-disable-next-line no-unused-vars
    checkStartDate(rule, value, callback) {
      if (!value) {
        callback(new Error("La fecha de inicio es requerida"));
      }
    },

    //Metodo para lanzar o no el dialog que pide el documento de evidencia
    evidenceDialog() {
      //console.log("evidencia call: ", this.model.Percentage)
      if (this.model.PercentageProsposal === 100 && !this.fileURL) {
        this.viewEvidenceDialog = true;
      } else {
        this.viewEvidenceDialog = false;
      }
    },

    //Metodo para cencelar el dialog que pide la evidencia
    onCancel() {
      this.fileList = [];
      this.fileURL = "";
      this.viewEvidenceDialog = false;
      this.UploadLoading = false;
    },

    onCancelDrawer() {
      this.$refs.drawer.closeDrawer();
      this.onCancel();
    },
    //Metodo para limpiar la evidencia al cerrar el modal que pide la evidencia o despues de subirla.
    onClose() {
      this.fileList = [];
      this.fileURL = "";
    },
    // Metodo para guardar el documento de evidencia
    async saveDocument() {
      this.UploadLoading = true;
      await this.$refs.uploadFile.submit();
    },
    handleExceed() {
      this.$message({
        type: "error",
        message: "Solo se permite subir un solo archivo."
      });
    },
    openFile(url = null) {
      //console.log("url: ", url)
      if (url !== null) {
        window.open(url, "_blank");
      } else {
        window.open(this.fileURL, "_blank");
      }
    },

    resetVariables() {
      this.fileView = false;
    },

    /*
    handleProgress(event, file, fileList) {


    },
    */

    //Este comentario es necesario para que eslint no se queje de los parámetros que no se usan pero que son necesarios para que funcione el método.
    // eslint-disable-next-line no-unused-vars
    handleSuccess(response, _file, _fileList) {
      /*
      console.log(
        "response: ", response, 
        "\n_file: ", _file, 
        "\n_fileList: ", _fileList
      )
      */
      const documentName = response;
      this.fileURL = documentName;
      this.$http
        .post(
          `/api/cmi/task/AddEvidenceTaskGantt?ID=${
            "Task-" + this.model.ID
          }&Evidence=${response[0].Url}`
        )
        .then(() => {
          let message = "Evidencia de la Tarea fue agregado exitosamente";
          this.$message.success(message);
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message
          });
        })
        .finally(() => {
          this.UploadLoading = false;
          this.viewEvidenceDialog = false;
          _fileList = [];
          this.drawer = false;
          this.$emit("update-table");
        });
      /*
        this.$message({
        type: "success",
        message: "Archivo suministrado con éxito"
      });
      */
    },
    // eslint-disable-next-line no-unused-vars
    handleError(err, file, fileList) {
      /*
       */
      this.UploadLoading = false;
      this.$message({
        type: "error",
        message: "Sucedió un error al intentar subir el archivo"
      });
    },
    handleEditFile() {
      this.viewEvidenceDialog = true;
      this.fileList = [];
    },
    getUpdatedData() {
      this.$emit("update-data");
    }
  },
  watch: {
    model(val) {
      if (process.env.NODE_ENV !== "development") {
        //console.log("watch", val);
        this.uploadUrl = `${BASE_API_URL}/api/CMI/Task/UploadFile?TaskID=${val.ID}`;
      } else {
        this.uploadUrl = `/api/CMI/Task/UploadFile?TaskID=${val.ID}`;
      }
    }
  }
};
</script>

<style scoped>
.tolltipStatus {
  margin: 1px;
  padding-left: 1px;
}
</style>
